require('./cardPINChangeError.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');

const cardPINChangeError = props => {
    const { immCard } = props;
    const errorSubMessage = formatText('cardPinChangeError-cardPinChangeError_errorMessage');
    const title = formatText('cardPinChangeError-cardPinChangeError_title');
    const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/details`;
    const goBackButton = {
        label: <FormattedText value="cardPinChangeError-cardPinChangeError_goBackButton" format="uppercase" />,
        url: linkToDetails
    };
    return (
        <article className="card-pin-change-error">
            <WizardError
                errorMessage={title}
                errorSubMessage={errorSubMessage}
                mainButton={goBackButton}
            >
                <section className="card-pin-change-error__additional-data">
                    <i className="icon icon-s-llamar card-pin-change-error__icon--right-icon"></i>
                    <FormattedText value="cardPinChangeError-cardPinChangeError_phoneNumberClients" />
                </section>
            </WizardError>
        </article>
    );
};

cardPINChangeError.propTypes = {
    immCard: PropTypes.object
}

module.exports = cardPINChangeError;
